export default function getAboutHeaderData(props) {
  const { headerTitle, headerIntro, headerImage, headerIntroductionTitle, headerIntroductionText, headerButton } =
    props;

  const data = {};
  data.title = headerTitle || false;
  data.description = headerIntro || false;

  data.storyTitle = headerIntroductionTitle || false;
  data.storyDescription = headerIntroductionText || false;

  data.figure = headerImage?.fields?.file ? {} : false;
  if (data.figure) {
    data.figure.alt = headerImage?.fields?.title || false;
    data.figure.src = headerImage?.fields?.file.url || false;
    data.figure.width = headerImage?.fields?.file.details?.image?.width || false;
    data.figure.height = headerImage?.fields?.file.details?.image?.height || false;
  }

  data.buttons = [];
  if (headerButton?.fields?.text) {
    const aboutHeaderButton = {};
    aboutHeaderButton.label = headerButton.fields.text;
    aboutHeaderButton.modifier = 'Button--electricPurple';
    aboutHeaderButton.url = headerButton.fields.url;
    data.buttons.push(aboutHeaderButton);
  }

  return Object.keys(data).length ? data : false;
}
